import {useContext} from 'react';

import { createContextProvider } from "../components/store-utils";
import { ExtendedTemplate } from "./extented-template-api";
import { useConfirm } from '../components/Dialogs';

export interface ExtendedTemplateState {
    templates?: ExtendedTemplate[]
    selected?: number
    changed?: boolean
}

export type ExtendedTemplateAction = 
{type: "setTemplates", payload: ExtendedTemplate[]} |
{type: "setSelected", payload: number} |
{type: "setChanged", payload: boolean}


function reducer(state: ExtendedTemplateState, action: ExtendedTemplateAction):ExtendedTemplateState{
    switch(action.type){
        case "setTemplates" : return {...state, templates: action.payload}
        case "setSelected" : return {...state, selected: action.payload}
        case "setChanged" : return {...state, changed: action.payload}
    }
}

export const [ExtendedTemplateContext, ExtendedTemplateStore] = createContextProvider(reducer, {})

export function useTemplateContext(){
    const {state} = useContext(ExtendedTemplateContext)
    return state;
}

export function useSetTemplates(){
    const {dispatch} = useContext(ExtendedTemplateContext)
    return (templates:ExtendedTemplate[]) => dispatch({type:"setTemplates", payload: templates});
}

export function useSelectTemplate(){
    const {dispatch} = useContext(ExtendedTemplateContext)
    return (template:number) => dispatch({type:"setSelected", payload: template});
}

export function useSetChanged(){
    const {dispatch} = useContext(ExtendedTemplateContext)
    return (changed:boolean) => dispatch({type:"setChanged", payload: changed});
}

export function useSelectedTemplate():ExtendedTemplate{
    const {selected, templates} = useTemplateContext()
    if(!templates) return null;
    if(selected === null) return null;
    return templates.find(t => t.id == selected);
}

export function useChangeConfirm<T>(callback:(n?:T)=>void){
    const {changed} = useTemplateContext()
    const setChanged = useSetChanged();
    const confirm = useConfirm("Deseja descartar as alterações?", {ok: "Sim"})

    return async (n?:T) =>{
        if(changed) {
            if(await confirm()) {
                setChanged(false);
                callback(n);
            }
        }
        else    
            callback(n);
    }
}